_collow.components.Escape = class Escape extends _collow.components.Base {
  constructor(root) {
    super();

    this.listen(root, "keydown", ({ key }) => {
      if (key == "Escape") this.dispatch(root, "_collow.escape.keydown");

      this.dispatch(root, "_collow.keydown");
    });
  }
};
